<div class="content">
  <div class="header">
    <label class="headerLabel">Auto-Select Loop Units</label>
  </div>
  @if (input.cooling) {
    <div class="inputRow">
      <mat-radio-group [(ngModel)]="input.sensibleTarget">
        <mat-radio-button class="radioOption" [value]="false">Select Units based on Total Cooling Load</mat-radio-button>
        <mat-radio-button class="radioOption" [value]="true">Select Units based on Sensible Cooling Load</mat-radio-button>
      </mat-radio-group>
    </div>
  }
  @if (!input.cooling) {
    <div class="inputRow">
      <mat-radio-group [(ngModel)]="input.sensibleTarget">
        <mat-radio-button class="radioOption" [value]="false">Select Units based on Total Heating Load</mat-radio-button>
      </mat-radio-group>
    </div>
  }
  <div class="separatorRow"></div>
  <div class="inputRow">
    <mat-radio-group [(ngModel)]="isSelectedOnly" (change)="behaviorChanged()">
      <mat-radio-button class="radioOption" [value]="false">Run Auto-Select for ALL zones</mat-radio-button>
      @if (selectedUnitIds.length > 0) {
        <mat-radio-button class="radioOption" [value]="true">Run Auto-Select for MARKED zones only</mat-radio-button>
      }
    </mat-radio-group>
  </div>
  <div class="buttonRow">
    <button class="dialogButton warn-button" matButton="elevated" (click)="cancel()">Cancel</button>
    <span class="spacer"></span>
    <button class="dialogButton primary-button" matButton="elevated" (click)="save()">Proceed</button>
  </div>
</div>
